import React, { useEffect, useState } from "react";
import {
  ComputerIcon2,
  ComputerIcon3,
  LeftChevron,
  LogoutIcon,
  RightChevron,
  RowingIcon,
  RowingIcon2,
} from "../Icons";
import { useAuthContext } from "../../context/auth";
import { getMonthlyPrograms, getProgram } from "../../client-api/program";
import { BaseProgram, CircuitProgram, BasicProgram } from "../../types";
import dayjs from "dayjs";
import Modal from "../Modal";
import cn from "../../utils/cn";
import { addRowing, getRowing } from "../../client-api/rowing";
import api from "../../lib/api";
import { TodayClassesDetailData } from "../../Api";
import {
  getCoolDownMinutes,
  getExerciseMinutes,
  getPartMinutes,
  getProgramMinutes,
  getTimeToKo,
  getWarmUpMinutes,
} from "../../utils/getMinute";

interface Program extends BaseProgram {
  program: BasicProgram | CircuitProgram;
}
function Admin() {
  const { logout, startProgram } = useAuthContext();
  const [classes, setClasses] = useState<TodayClassesDetailData>([]);
  const [selected, setSelected] = useState<"program" | "row">("program");

  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState<Program[]>([]);
  const [row, setRow] = useState<"300m" | "600m" | "1200m">();
  const [selectedProgram, setSelectedProgram] = useState<Program | null>(null);
  const [program, setProgram] = useState<BasicProgram | CircuitProgram | null>(
    null
  );

  const [showVideo, setShowVideo] = useState(false);
  const [video, setVideo] = useState<string | null>(null);
  const [pins, setPins] = useState<string[]>([]);
  const [edit, setEdit] = useState(false);
  const [selectedClassId, setSelectedClassId] = useState<number | null>(null);

  useEffect(() => {
    if (selectedProgram) {
      getProgram(String(selectedProgram.id)).then((data) => {
        console.log(data);
        setProgram(data as BasicProgram | CircuitProgram);
      });
    }
  }, [selectedProgram]);

  const getData = () => {
    const year = month.split("-")[0];
    const montha = month.split("-")[1];
    if (!year || !montha) return;
    getMonthlyPrograms(Number(year), Number(montha)).then((data) => {
      setData(
        data
          .map((item) => ({
            ...item,
            program: JSON.parse(item.programJson) as
              | BasicProgram
              | CircuitProgram,
          }))
          .sort((a, b) => dayjs(b.useDate).diff(dayjs(a.useDate)))
      );
    });
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const username = localStorage.getItem("username");
    if (username) {
      api.fits.todayClassesDetail(username).then((res) => {
        setSelectedClassId(res.data?.[0]?.id);
        setClasses(res.data);
      });
    }
  }, []);

  return (
    <div className="h-full">
      <div className="flex h-full">
        <div className="flex flex-col items-stretch w-[16%] h-full">
          <div className="items-stretch self-stretch bg-[#000000] flex w-full grow flex-col mx-auto pl-4 lg:pl-10">
            <div className="justify-center flex flex-col pr-16 py-6 border-b-slate-600 border-b border-solid items-start max-md:pr-5">
              <img
                loading="lazy"
                src="/logo.png"
                className="aspect-[2.06] object-contain object-center w-[140px] justify-center items-center overflow-hidden max-w-full"
                alt="logo"
              />
            </div>
            <div className="text-slate-400 text-lg mt-10">프로그램 관리</div>
            <button
              className="items-stretch bg-white flex justify-between gap-2.5 mt-6 px-3 py-4 rounded-l max-md:pr-5"
              onClick={() => setSelected("program")}
            >
              <ComputerIcon3 />
              <div className="text-gray-950 text-xl grow whitespace-nowrap">
                월간 프로그램
              </div>
            </button>
            <div className="justify-end items-stretch flex flex-col grow pr-6 py-8 border-t-slate-600 border-t border-solid max-md:mt-10 max-md:pr-5">
              <div
                className="items-stretch bg-slate-600 flex justify-between gap-2.5 pl-6 pr-3 py-4 rounded-lg"
                onClick={() => {
                  logout();
                }}
              >
                <LogoutIcon />
                <div className="text-white text-lg font-bold self-center grow whitespace-nowrap my-auto">
                  로그아웃
                </div>
              </div>
            </div>
          </div>
        </div>
        {selected === "program" ? (
          <div className="flex flex-col items-stretch flex-1">
            <div className="items-stretch self-stretch flex grow flex-col w-full max-h-full">
              <div className="bg-beige-light flex flex-col justify-center pr-16 border-b-slate-200 border-b border-solid items-start max-md:max-w-full max-md:pr-5">
                <div className="flex-col fill-bg-dark overflow-hidden relative flex aspect-[3.4482758620689653] w-[400px] max-w-full justify-center pl-6 pr-16 py-9 items-start max-md:px-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="400"
                    height="116"
                    viewBox="0 0 400 116"
                    fill="none"
                    className="absolute h-full w-full object-cover object-center inset-0"
                  >
                    <path d="M0 0H400L355.311 116H0V0Z" fill="#000000" />
                  </svg>
                  <div className="relative items-center flex gap-3">
                    <ComputerIcon2 />
                    <div className="text-white text-4xl font-bold self-stretch grow whitespace-nowrap">
                      월간 프로그램
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-1 overflow-y-scroll">
                <div className="bg-slate-50 max-md:max-w-full max-h-full">
                  <div className="gap-5 flex max-md:flex-col max-md:items-stretch max-md:gap-0 h-full">
                    <div className="flex flex-col items-stretch max-h-full overflow-y-scroll">
                      <div className="self-stretch bg-white flex grow flex-col items-stretch w-full border-x-slate-200 border-r border-solid border-l max-md:max-w-full max-md:mt-2.5">
                        <div className="justify-center bg-white flex flex-col pl-6 pr-16 py-6 items-start max-md:max-w-full max-md:px-5">
                          <div className="items-stretch flex gap-2">
                            <div className="text-black text-center text-xl font-bold grow whitespace-nowrap">
                              월간 프로그램
                            </div>
                            <div className="text-beige-dark text-center text-xl font-bold whitespace-nowrap">
                              {data.length}
                            </div>
                          </div>
                        </div>
                        <div className="items-stretch bg-white flex flex-col pb-6 px-6 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:px-5">
                          <div className="items-stretch flex justify-between gap-3 max-md:max-w-full max-md:flex-wrap">
                            <input
                              placeholder="월"
                              type="month"
                              onChange={(e) => {
                                setMonth(e.target.value);
                              }}
                              value={month}
                              className="items-stretch rounded border bg-slate-50 flex justify-between gap-2.5 pl-3 pr-1.5 py-1.5 border-solid border-slate-400 max-md:max-w-full max-md:flex-wrap"
                            ></input>
                            <div
                              onClick={() => getData()}
                              className="text-black text-lg whitespace-nowrap items-stretch rounded bg-gradient-beige aspect-[1.696969696969697] justify-center px-3 py-1.5"
                            >
                              검색
                            </div>
                          </div>
                        </div>
                        <div className="items-stretch bg-slate-50 flex gap-5 mt-11 px-6 py-4 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:mt-10 max-md:px-5">
                          <div className="text-black text-lg whitespace-nowrap">
                            순서
                          </div>
                          <div className="text-black text-lg">사용날짜</div>
                          <div className="text-black text-lg">프로그램명</div>
                          <div className="text-black text-lg grow whitespace-nowrap">
                            종류
                          </div>
                        </div>
                        {data.map((item, index) => (
                          <button
                            className={cn(
                              "items-stretch flex gap-5 px-6 py-3 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:px-5",
                              selectedProgram?.id === item.id
                                ? "bg-slate-100 font-bold"
                                : "bg-white"
                            )}
                            onClick={() => {
                              setSelectedProgram(item);
                            }}
                          >
                            <div className="text-black text-lg whitespace-nowrap">
                              {index + 1}
                            </div>
                            <div className="text-black text-lg">
                              {dayjs(item.useDate).format("YYYY.MM.DD")}
                            </div>
                            <div className="text-black text-lg">
                              {item.name}
                            </div>
                            <div className="text-black text-lg grow whitespace-nowrap">
                              {item.programType === "BASIC"
                                ? "BASIC"
                                : item.programType === "CIRCUIT1"
                                ? "기구 서킷1"
                                : "기구 서킷2"}
                            </div>
                          </button>
                        ))}
                        <div className="justify-center items-center bg-slate-50 flex flex-col px-16 py-4 border-t-slate-200 border-t border-solid max-md:max-w-full max-md:px-5">
                          <div className="justify-between items-start flex gap-3 max-md:max-w-full max-md:flex-wrap">
                            {/* <LeftChevron /> */}
                            <div className="text-black text-center text-lg self-center my-auto">
                              1
                            </div>
                            {/* <RightChevron /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {selectedProgram && program && (
                      <div className="flex flex-col items-stretch flex-1 overflow-y-scroll max-h-full">
                        <div className="bg-white flex grow flex-col w-full border-l-slate-200 border-l">
                          <div className="justify-between items-center bg-white self-stretch flex gap-5 p-6 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:px-5">
                            <div className="text-black text-center text-xl font-bold my-auto">
                              수업 프로그램
                            </div>
                            <div className="flex itmes-center gap-4">
                              <select
                                className="rounded border border-[#8D9CB6] bg-[#F8F8FC] gap-[10px] pl-3 pr-[6px] self-center h-[32px]"
                                value={String(selectedClassId)}
                                onChange={(e) => {
                                  setSelectedClassId(Number(e.target.value));
                                }}
                              >
                                {classes?.map((item) => (
                                  <option value={String(item.id)}>
                                    <span className="text-[#8D9CB6]">
                                      {dayjs(item.startedAt).format("HH:mm") +
                                        "~" +
                                        dayjs(item.endedAt).format("HH:mm")}
                                    </span>{" "}
                                    {" / "}
                                    {item.name}
                                    {" / "}
                                    <span className="text-beige-dark">
                                      {item.roomName}
                                    </span>
                                  </option>
                                ))}
                              </select>

                              <button
                                className="text-white text-center text-lg font-bold whitespace-nowrap justify-center items-stretch bg-gradient-beige self-stretch px-5 py-5 rounded-lg"
                                onClick={() => {
                                  // if (!selectedClassId) return;
                                  startProgram(
                                    selectedProgram.id,
                                    row,
                                    selectedClassId ?? undefined
                                  );
                                }}
                              >
                                수업 시작
                              </button>
                            </div>
                          </div>
                          <div className="items-stretch flex w-[669px] max-w-full justify-between gap-5 ml-6 mt-6 pr-20 self-start max-md:flex-wrap max-md:pr-5">
                            <div className="items-stretch flex justify-between gap-4">
                              <div className="text-slate-600 text-lg grow whitespace-nowrap">
                                사용날짜
                              </div>
                              <div className="text-black text-lg font-bold grow whitespace-nowrap">
                                {dayjs(selectedProgram.useDate).format(
                                  "YYYY.MM.DD"
                                )}
                              </div>
                            </div>
                            <div className="items-stretch flex justify-between gap-4">
                              <div className="text-slate-600 text-lg">
                                프로그램명
                              </div>
                              <div className="text-black text-lg font-bold">
                                {selectedProgram.name}
                              </div>
                            </div>
                            <div className="items-stretch flex justify-between gap-4">
                              <div className="text-slate-600 text-lg">종류</div>
                              <div className="text-black text-lg font-bold">
                                {selectedProgram.programType === "BASIC"
                                  ? "BASIC"
                                  : selectedProgram.programType === "CIRCUIT1"
                                  ? "기구 서킷1"
                                  : "기구 서킷2"}
                              </div>
                            </div>
                          </div>
                          <div className="justify-center bg-white self-stretch flex flex-col mt-9 pl-8 pr-16 py-6 items-start max-md:max-w-full max-md:px-5">
                            <div className="items-stretch flex gap-2">
                              <div className="text-black text-center text-xl font-bold grow whitespace-nowrap">
                                운동 소요 시간
                              </div>
                              <div className="text-beige-dark text-center text-xl font-bold whitespace-nowrap">
                                {getTimeToKo(
                                  getProgramMinutes({
                                    program,
                                    programType: program.programType,
                                  })
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="self-stretch mx-6 max-md:max-w-full max-md:mr-2.5">
                            <div className="flex">
                              <div className="flex flex-col items-stretch flex-1">
                                <div className="items-stretch flex grow flex-col max-md:max-w-full">
                                  <div className="items-stretch flex justify-between gap-0 max-md:max-w-full max-md:flex-wrap">
                                    <div className="text-black text-lg whitespace-nowrap items-stretch bg-slate-50 justify-center pl-6 py-3 border-b-slate-200 border-b border-solid w-[175px]">
                                      Warm up
                                    </div>
                                    <div className="text-black text-lg whitespace-nowrap items-stretch grow justify-center px-6 py-3 border-b-slate-200 border-b border-solid max-md:px-5">
                                      {getTimeToKo(getWarmUpMinutes(program))}
                                    </div>
                                    <div className="text-black text-lg whitespace-nowrap items-stretch bg-slate-50 justify-center pl-6 py-3 border-b-slate-200 border-b border-solid w-[175px]">
                                      Cool Down
                                    </div>
                                    <div className="text-black text-lg whitespace-nowrap items-stretch grow justify-center px-6 py-3 border-b-slate-200 border-b border-solid max-md:px-5">
                                      {getTimeToKo(getCoolDownMinutes(program))}
                                    </div>
                                  </div>
                                  <div className="items-stretch flex justify-between gap-0 max-md:max-w-full max-md:flex-wrap">
                                    <div className="text-black text-lg whitespace-nowrap items-stretch bg-slate-50 justify-center pl-6 py-3 border-b-slate-200 border-b border-solid w-[175px]">
                                      Main
                                    </div>
                                    <div className="text-black text-lg whitespace-nowrap items-stretch grow justify-center px-6 py-3 border-b-slate-200 border-b border-solid max-md:px-5">
                                      {program.programType === "BASIC"
                                        ? getTimeToKo(
                                            getExerciseMinutes(
                                              program as BasicProgram
                                            )
                                          )
                                        : getTimeToKo(
                                            getPartMinutes(
                                              (program as CircuitProgram).part1
                                            ) +
                                              getPartMinutes(
                                                (program as CircuitProgram)
                                                  .part2
                                              )
                                          )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="text-black text-xl font-bold whitespace-nowrap justify-center bg-white w-[717px] max-w-full mt-6 pl-6 pr-16 py-6 self-start items-start max-md:px-5">
                            프로그램 상세
                          </div>
                          <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                            <div className="text-black text-lg font-bold whitespace-nowrap bg-slate-50 grow justify-center pl-6 pr-16 py-3 border-b-slate-200 border-b border-solid items-start max-md:max-w-full max-md:px-5">
                              Warm up - {getTimeToKo(getWarmUpMinutes(program))}
                            </div>
                          </div>
                          {program.warmUpMovements.map((item) => (
                            <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                              <div className="flex-1 justify-between items-stretch flex gap-5 px-6 py-3 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:px-5">
                                <div className="items-stretch flex gap-4">
                                  <img
                                    loading="lazy"
                                    className="aspect-square object-contain object-center w-[60px] justify-center items-center overflow-hidden shrink-0 max-w-full"
                                    src={item.movement.image}
                                    alt="동작 이미지"
                                  />
                                  <div className="text-black text-lg self-center my-auto">
                                    {item.movement.name}
                                  </div>
                                </div>
                                <div className="flex gap-4 items-center">
                                  <p className="text-sm">
                                    {item.movement.direction} / {item.time}
                                  </p>
                                  <img
                                    loading="lazy"
                                    className="aspect-square object-contain object-center w-6 justify-center items-center overflow-hidden self-center shrink-0 max-w-full my-auto"
                                    src="/right-chevron.png"
                                    alt="동작 이미지"
                                    onClick={() => {
                                      setShowVideo(true);
                                      setVideo(item.movement.video);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                          {program.programType === "CIRCUIT1" ||
                          program.programType === "CIRCUIT2" ? (
                            <>
                              <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                                <div className="text-black text-lg font-bold whitespace-nowrap bg-slate-50 grow justify-center pl-6 pr-16 py-3 border-b-slate-200 border-b border-solid items-start max-md:max-w-full max-md:px-5">
                                  Part 1 -{" "}
                                  {getTimeToKo(
                                    getPartMinutes(
                                      (program as CircuitProgram).part1
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="border-b border-gray-200">
                                <div className="flex">
                                  <div className="flex-1 flex justify-center items-center gap-3 p-3">
                                    <span className="text-sm font-normal">
                                      동작 시간
                                    </span>
                                    <span className="text-sm font-normal">
                                      {(program as CircuitProgram).part1.time}
                                    </span>
                                  </div>

                                  <div className="flex-1 flex justify-center items-center gap-3 p-3">
                                    <span className="text-sm font-normal">
                                      쉬는 시간
                                    </span>
                                    <span className="text-sm font-normal">
                                      {
                                        (program as CircuitProgram).part1
                                          .restTime
                                      }
                                    </span>
                                  </div>

                                  <div className="flex-1 flex justify-center items-center gap-3 p-3">
                                    <span className="text-sm font-normal">
                                      반복 횟수
                                    </span>
                                    <span className="text-sm font-normal">
                                      {
                                        (program as CircuitProgram).part1
                                          .repeatCount
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                              {(program as CircuitProgram).part1.movements?.map(
                                (item, index) => (
                                  <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                                    <div className="flex-1 justify-between items-stretch flex gap-5 px-6 py-3 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:px-5">
                                      <div className="items-stretch flex justify-between gap-4">
                                        <img
                                          loading="lazy"
                                          className="aspect-square object-contain object-center w-[60px] justify-center items-center overflow-hidden shrink-0 max-w-full"
                                          src={item.image}
                                          alt="동작 이미지"
                                        />
                                        <div className="text-black text-lg self-center my-auto">
                                          {item.name}
                                        </div>
                                      </div>
                                      <div className="flex gap-4 items-center">
                                        <p className="text-sm">
                                          {item.direction} /{" "}
                                          {
                                            (program as CircuitProgram).part1
                                              .time
                                          }
                                        </p>
                                        <img
                                          loading="lazy"
                                          className="aspect-square object-contain object-center w-6 justify-center items-center overflow-hidden self-center shrink-0 max-w-full my-auto"
                                          src="/right-chevron.png"
                                          alt="동작 이미지"
                                          onClick={() => {
                                            setShowVideo(true);
                                            setVideo(item.video);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="text-black text-lg whitespace-nowrap justify-center items-center px-16 py-8 border-b-slate-200 border-b border-solid max-md:px-5">
                                      {`${index + 1}`}
                                    </div>
                                  </div>
                                )
                              )}
                              <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                                <div className="text-black text-lg font-bold whitespace-nowrap bg-slate-50 grow justify-center pl-6 pr-16 py-3 border-b-slate-200 border-b border-solid items-start max-md:max-w-full max-md:px-5">
                                  Part 2 -{" "}
                                  {getTimeToKo(
                                    getPartMinutes(
                                      (program as CircuitProgram).part2
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="border-b border-gray-200">
                                <div className="flex">
                                  <div className="flex-1 flex justify-center items-center gap-3 p-3">
                                    <span className="text-sm font-normal">
                                      동작 시간
                                    </span>
                                    <span className="text-sm font-normal">
                                      {(program as CircuitProgram).part2.time}
                                    </span>
                                  </div>

                                  <div className="flex-1 flex justify-center items-center gap-3 p-3">
                                    <span className="text-sm font-normal">
                                      쉬는 시간
                                    </span>
                                    <span className="text-sm font-normal">
                                      {
                                        (program as CircuitProgram).part2
                                          .restTime
                                      }
                                    </span>
                                  </div>

                                  <div className="flex-1 flex justify-center items-center gap-3 p-3">
                                    <span className="text-sm font-normal">
                                      반복 횟수
                                    </span>
                                    <span className="text-sm font-normal">
                                      {
                                        (program as CircuitProgram).part2
                                          .repeatCount
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                              {(program as CircuitProgram).part2.movements?.map(
                                (item, index) => (
                                  <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                                    <div className="flex-1 justify-between items-stretch flex gap-5 px-6 py-3 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:px-5">
                                      <div className="items-stretch flex justify-between gap-4">
                                        <img
                                          loading="lazy"
                                          className="aspect-square object-contain object-center w-[60px] justify-center items-center overflow-hidden shrink-0 max-w-full"
                                          src={item.image}
                                          alt="동작 이미지"
                                        />
                                        <div className="text-black text-lg self-center my-auto">
                                          {item.name}
                                        </div>
                                      </div>
                                      <div className="flex gap-4 items-center">
                                        <p className="text-sm">
                                          {item.direction} /{" "}
                                          {
                                            (program as CircuitProgram).part1
                                              .time
                                          }
                                        </p>
                                        <img
                                          loading="lazy"
                                          className="aspect-square object-contain object-center w-6 justify-center items-center overflow-hidden self-center shrink-0 max-w-full my-auto"
                                          src="/right-chevron.png"
                                          alt="동작 이미지"
                                          onClick={() => {
                                            setShowVideo(true);
                                            setVideo(item.video);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="text-black text-lg whitespace-nowrap justify-center items-center px-16 py-8 border-b-slate-200 border-b border-solid max-md:px-5">
                                      {`${index + 1}`}
                                    </div>
                                  </div>
                                )
                              )}
                            </>
                          ) : (
                            <>
                              <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                                <div className="text-black text-lg font-bold whitespace-nowrap bg-slate-50 grow justify-center pl-6 pr-16 py-3 border-b-slate-200 border-b border-solid items-start max-md:max-w-full max-md:px-5">
                                  Main EXER -{" "}
                                  {getTimeToKo(
                                    getExerciseMinutes(program as BasicProgram)
                                  )}
                                </div>
                              </div>
                              {(program as BasicProgram).mainExers.map(
                                (item) => (
                                  <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                                    <div className="flex-1 justify-between items-stretch flex gap-5 px-6 py-3 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:px-5">
                                      <div className="items-stretch flex gap-4">
                                        <img
                                          loading="lazy"
                                          className="aspect-square object-contain object-center w-[60px] justify-center items-center overflow-hidden shrink-0 max-w-full"
                                          src={item.movement.image}
                                          alt="동작 이미지"
                                        />
                                        <div className="text-black text-lg self-center my-auto">
                                          {item.movement.name}
                                        </div>
                                      </div>
                                      <div className="flex gap-4 items-center">
                                        <p className="text-sm">
                                          {item.movement.direction} /{" "}
                                          {item.time}
                                        </p>
                                        <img
                                          loading="lazy"
                                          className="aspect-square object-contain object-center w-6 justify-center items-center overflow-hidden self-center shrink-0 max-w-full my-auto"
                                          src="/right-chevron.png"
                                          alt="동작 이미지"
                                          onClick={() => {
                                            setShowVideo(true);
                                            setVideo(item.movement.video);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                            </>
                          )}

                          <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                            <div className="text-black text-lg font-bold whitespace-nowrap bg-slate-50 grow justify-center pl-6 pr-16 py-3 border-b-slate-200 border-b border-solid items-start max-md:max-w-full max-md:px-5">
                              쿨다운 -{" "}
                              {getTimeToKo(getCoolDownMinutes(program))}
                            </div>
                          </div>
                          {program.coolDownMovements.map((item) => (
                            <div className="items-stretch self-stretch flex justify-between gap-0 mx-6 max-md:max-w-full max-md:flex-wrap max-md:mr-2.5">
                              <div className="flex-1 justify-between items-stretch flex gap-5 px-6 py-3 border-b-slate-200 border-b border-solid max-md:max-w-full max-md:flex-wrap max-md:px-5">
                                <div className="items-stretch flex gap-4">
                                  <img
                                    loading="lazy"
                                    className="aspect-square object-contain object-center w-[60px] justify-center items-center overflow-hidden shrink-0 max-w-full"
                                    src={item.movement.image}
                                    alt="동작 이미지"
                                  />
                                  <div className="text-black text-lg self-center my-auto">
                                    {item.movement.name}
                                  </div>
                                </div>
                                <div className="flex gap-4 items-center">
                                  <p className="text-sm">
                                    {item.movement.direction} / {item.time}
                                  </p>
                                  <img
                                    loading="lazy"
                                    className="aspect-square object-contain object-center w-6 justify-center items-center overflow-hidden self-center shrink-0 max-w-full my-auto"
                                    src="/right-chevron.png"
                                    alt="동작 이미지"
                                    onClick={() => {
                                      setShowVideo(true);
                                      setVideo(item.movement.video);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <Modal
        open={showVideo}
        handleClose={() => {
          setShowVideo(false);
          setVideo(null);
        }}
      >
        <div className="flex items-center justify-center w-full h-full">
          <video className="w-[1000px] h-[562px]" controls autoPlay key={video}>
            <source src={video ?? ""} type="video/mp4" />
          </video>
        </div>
      </Modal>
    </div>
  );
}

export default Admin;
